<script>
    import store from "../../store";

    import QuotePanel from '../onboarding/QuotePanel';
    import BillContainer from '../onboarding/bill/BillContainer';
    import BillInfoModal from '../onboarding/bill/BillInfoModal';
    import BillCompareModal from '../onboarding/bill/BillCompareModal';

    export default {
        name: "GetQuoteForm",

        props: {
            'package' : {
                type: Array,
                required: true
            }
        },

        components: {
            QuotePanel,
            BillContainer,
            BillInfoModal,
            BillCompareModal
        },

        mounted() {
            store.commit('quote/setBills', this.package);
            store.commit('quote/selectAutoSelected');
            store.commit('quote/selectPerkBills');
        },

        methods: {

        },

        computed: {
            groupedBills() {
                return this.$store.getters['quote/getGroupedBills'];
            },

            selectedBills() {
                return this.$store.getters['quote/getSelectedBills'];
            },

            freePerks() {
                return this.$store.getters['quote/getFreePerks'];
            }
        }

    }
</script>
